import egumaReact from "egumaReact"; // added in externals in webpack
import { Element } from "react-scroll";
import React, { Fragment } from "react";

import Polyglot from "node-polyglot";
const polyglot = new Polyglot({ phrases: egumaReact.translations });

function TimeSlots({
  hasPromocodeForm,
  currentDate,
  onSelect,
  selectedTimeSlot,
  timeSlots
}) {
  if (!currentDate || egumaReact.isAllDay) {
    return null;
  }

  if (!timeSlots || timeSlots.length === 0) {
    return (
      <Element name="timeSlots">
        <div style={{ marginTop: 30 }}>
          {hasPromocodeForm
            ? polyglot.t("Shop.Error.NoTicketsAvailablePromocode")
            : polyglot.t("Shop.Error.NoTicketsAvailable")}
        </div>
      </Element>
    );
  }

  return (
    <Element name="timeSlots">
      <div style={{ marginTop: 30 }}>
        <div>
          {polyglot.t("Backend.Ticketing.Calendar.PleaseChooseTime")}
          <div
            style={{
              display: "flex",
              flexWrap: "wrap",
              marginTop: 10
            }}
          >
            {timeSlots.map(
              ({ id, time, enabled, isFullyBooked, capacity }, index) => (
                <div
                  key={index}
                  onClick={() => (enabled ? onSelect({ slotId: id }) : null)}
                >
                  <div
                    className={`calendar--timeslot${
                      enabled
                        ? " calendar--timeslot-enabled"
                        : " calendar--timeslot-disabled"
                    }${
                      selectedTimeSlot && selectedTimeSlot === id
                        ? " calendar--timeslot-selected"
                        : ""
                    }`}
                  >
                    {time}
                    {egumaReact.showAvailability && (
                      <Fragment>
                        <br />
                        <div className="calendar--timeslot-available">
                          {enabled
                            ? polyglot.t(
                                "Shop.Calendar.TicketAmountAvailable",
                                {
                                  capacity
                                }
                              )
                            : isFullyBooked
                            ? polyglot.t("Common.SoldOut")
                            : polyglot.t("Common.SaleClosed")}
                        </div>
                      </Fragment>
                    )}
                  </div>
                </div>
              )
            )}
          </div>
        </div>
      </div>
    </Element>
  );
}

export default TimeSlots;
